module.exports = __webpack_public_path__ + "static/media/ic_close.97082053.svg";